"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectExtendedResponseModelApplyTextNormalization = void 0;
exports.ProjectExtendedResponseModelApplyTextNormalization = {
    Auto: "auto",
    On: "on",
    Off: "off",
    ApplyEnglish: "apply_english",
};
